export let CloseComposeActionName = 'closeCompose';
export let openComposeActionName = 'openCompose';
